export default "__VITE_ASSET__DRj037YV__"